import { Container, Reveal, RevealGroup } from '@/components/common'
import { partnerTypes, partnerReasons } from '@/constants/partnership'

export const WhyPartner = () => {
  return (
    <section className="bg-ibon-dark py-24 lg:py-32">
      <Container>
        <div className="grid gap-16 lg:grid-cols-[1fr_1.2fr] lg:gap-24">
          {/* Left: who we partner with */}
          <div>
            <Reveal variant="up" delay={100}>
              <h2 className="mt-7 text-4xl font-bold leading-[1.02] tracking-[-0.02em] text-white sm:text-5xl">
                A diverse <span className="text-white/30">network.</span>
              </h2>
            </Reveal>
            <RevealGroup className="mt-10 flex flex-wrap gap-3" step={50}>
              {partnerTypes.map((partner) => (
                <span
                  key={partner}
                  className="rounded-full border border-white/15 bg-white/5 px-5 py-2.5 text-sm font-medium text-white/80"
                >
                  {partner}
                </span>
              ))}
            </RevealGroup>
          </div>

          {/* Right: why partner */}
          <div>
            <Reveal variant="up" delay={120}>
              <h3 className="text-xs font-semibold uppercase tracking-[0.25em] text-ibon-sky">
                Why Partner With IBON World
              </h3>
            </Reveal>
            <RevealGroup
              className="mt-8 divide-y divide-white/10 border-t border-white/10"
              step={80}
            >
              {partnerReasons.map(({ Icon, text }) => (
                <div key={text} className="flex items-center gap-5 py-6">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-white/5 text-ibon-sky">
                    <Icon size={20} />
                  </span>
                  <p className="text-lg font-medium leading-snug text-white">{text}</p>
                </div>
              ))}
            </RevealGroup>
          </div>
        </div>
      </Container>
    </section>
  )
}
